<template>
  <div>
    <form id="delete" @submit.prevent="showModal = true">
        <input type="submit" class="submit" v-bind:value="$t('admin.adminNotificationDelete.button.delete')">
    </form>
    <Modal class="alert" v-if="showModal" v-bind:modalTitle="$t('admin.adminNotificationDelete.modal.header', {name: notification.subject})" @close="showModal = false">
      <p class="modal-text">{{ $t('admin.adminNotificationDelete.modal.text') }}</p>
      <a v-on:click.prevent="deleteNotification" class="button" href="#">{{ $t("admin.adminNotificationDelete.modal.button") }}</a>
    </Modal>
  </div>
</template>

<script>
import Modal from '@/components/Modal.vue'

import { adminService } from '@/services/admin.service'

export default {
  props: ['notification'],
  name: 'AdminNotificationDelete',
  components: {
    Modal
  },
  data: function () {
    return {
      showModal: false
    }
  },
  methods: {
    deleteNotification: function () {
      adminService.notificationDelete(this.notification.id).then(() => {
        console.log('delete notification: ' + this.notification.subject)
        this.showModal = false
        this.$router.push('/admin/notificationList/')
      }).catch((err) => {
        console.error('Unable to delete notification: ', err)
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.modal-text {
  font-weight: bold;
}
</style>
